import React, { useEffect, useState } from 'react';
import * as S from './ReadingFIBRW.styles';
import { ScoreInfo } from '@app/components/exam/ScoreInfo';

interface Props {
  showAnswer: boolean;
  text: string;
  initialChoicesString: string;
  correctAnswersString: string;
  questionNumber: string;
  onAnswerChange?: (answer: string) => void;
}

export const ReadingFIBRW: React.FC<Props> = ({
  showAnswer,
  text,
  initialChoicesString,
  correctAnswersString,
  questionNumber,
  onAnswerChange,
}) => {
  const numberOfBlanks = (text.match(/@Blank@/g) || []).length;
  const [filledBlanks, setFilledBlanks] = useState<string[]>(new Array(numberOfBlanks).fill(''));
  const [choices, setChoices] = useState<{ label: string; text: string }[]>([]);
  const [correctAnswers, setCorrectAnswers] = useState<string[]>([]);
  const [scoreLoaded, setScoreLoaded] = useState(false);

  useEffect(() => {
    setFilledBlanks(new Array(numberOfBlanks).fill(''));
    if (initialChoicesString) {
      const parsedChoices = JSON.parse(initialChoicesString);
      setChoices(parsedChoices);
    }
  }, [initialChoicesString]);

  useEffect(() => {
    if (correctAnswersString) {
      const resultArray = correctAnswersString.split(',').map((item) => item.trim());
      setCorrectAnswers(resultArray);
    }
  }, [correctAnswersString]);

  const handleChangeAnswer = (e: React.ChangeEvent<HTMLSelectElement>, index: number) => {
    const updatedFilledBlanks = [...filledBlanks];
    updatedFilledBlanks[index] = e.target.value;
    setFilledBlanks(updatedFilledBlanks);
    onAnswerChange && onAnswerChange(updatedFilledBlanks.join(','));
  };

  const textWithBlanks = text.split(/@Blank@/).map((part, index) => {
    const filledBlank = filledBlanks[index] || '';
    const isBlank = index < filledBlanks.length;
    const isCorrect = filledBlank === correctAnswers[index];

    return (
      <React.Fragment key={`part-${index}`}>
        {part}
        {isBlank && (
          <S.SelectStyle
            name="select"
            style={{
              borderColor: showAnswer && scoreLoaded ? (isCorrect ? 'green' : 'red') : '#000',
            }}
            value={filledBlank}
            onChange={(e) => handleChangeAnswer(e, index)}
          >
            <option value=""></option>
            {choices.length > 0 &&
              choices[index].text.split('/').map((word) => (
                <option key={`${choices[index].label}-${word}`} value={word}>
                  {word}
                </option>
              ))}
          </S.SelectStyle>
        )}
        {showAnswer && !isCorrect && correctAnswers[index] && (
          <S.CorrectAnswer>({correctAnswers[index]})</S.CorrectAnswer>
        )}
      </React.Fragment>
    );
  });

  return (
    <>
      <S.Wrapper>
        <S.ContenQuestion>{textWithBlanks}</S.ContenQuestion>
      </S.Wrapper>
      {showAnswer && (
        <ScoreInfo
          answer={filledBlanks.join(',') || ''}
          questionId={questionNumber}
          onLoaded={() => setScoreLoaded(true)}
        />
      )}
    </>
  );
};
